import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for pending prize payments.
 * @extends JetView
 */
export default class tablePremiosPendientesPagarView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node's inner HTML
                },
            },
            webix.ui.datafilter.summColumn, // Extend the summColumn filter
        );

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Tree table view
                            id: 'treetable', // Unique ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            bready: function () {
                                this.openAll(); // Open all rows in the tree table
                            },
                            footer: false, // Disable footer
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'CreationDate', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 150, // Column width
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Display group value
                                            );
                                        return obj.CreationDate; // Return creation date
                                    },
                                    footer: 'Total:', // Footer label
                                },
                                {
                                    id: 'ValueBet', // Column ID
                                    header: _('Valor Apostado'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                },
                                {
                                    id: 'ValuePrize', // Column ID
                                    header: _('Valor Premio'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        _("<div style='margin:75px; font-size:18px;'>No hay datos</div>"),
                                    );
                                }
                            },
                            autowidth: false, // Disable auto width
                            math: true, // Enable math operations
                            datafetch: 10, // Number of records to fetch
                            pager: 'pagerA', // Pager ID
                        },
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique ID for the data table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            bready: function () {
                                this.openAll(); // Open all rows in the data table
                            },
                            footer: true, // Enable footer
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'NoTicket', // Column ID
                                    header: _('No. Ticket'), // Column header with localization
                                    width: 250, // Column width
                                },
                                {
                                    id: 'CreationDate', // Column ID
                                    header: _('Fecha Creación'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'CreationTime', // Column ID
                                    header: _('Hora de creación'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'DatePrize', // Column ID
                                    header: _('Fecha Premio'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'TimePrize', // Column ID
                                    header: _('Hora Premio'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'ValueBet', // Column ID
                                    header: _('Valor Apostado'), // Column header with localization
                                    footer: { content: 'summColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                },
                                {
                                    id: 'ValuePrize', // Column ID
                                    header: _('Valor Premio'), // Column header with localization
                                    footer: { content: 'summColumn' }, // Footer content for summation
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Currency', // Column ID
                                    header: _('Moneda'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'PointSale', // Column ID
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 250, // Column width
                                },
                                {
                                    id: 'ExpiredDate', // Column ID
                                    header: _('Fecha Caducidad Pago'), // Column header with localization
                                    width: 150, // Column width
                                },
                                {
                                    id: 'Expired', // Column ID
                                    header: _('Caduco'), // Column header with localization
                                    width: 150, // Column width
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        _("<div style='margin:75px; font-size:18px;'>No hay datos</div>"),
                                    );
                                }
                            },
                            autowidth: false, // Disable auto width
                            math: true, // Enable math operations
                            datafetch: 10, // Number of records to fetch
                            pager: 'pagerA2', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('treetable'); // Reference to the tree table
        var url = devConfig.geturlApi() + 'es/Report/GetPremiosPendientes'; // API endpoint for fetching data
        var filter = ''; // Initialize filter string

        // Event listener for after loading data
        grid.attachEvent('onAfterLoad', function () {
            $$('treetable').data.group({
                // Group data by PointSale
                by: 'PointSale',
                map: {
                    PointSale: ['PointSale'],
                    Currency: ['Currency'],
                    ValueBet: ['ValueBet', 'sum'], // Sum ValueBet
                    ValuePrize: ['ValuePrize', 'sum'], // Sum ValuePrize
                },
            });
            $$('treetable').data.group({
                // Group data by Currency
                by: 'Currency',
                map: {
                    ValueBet: ['ValueBet', 'sum'], // Sum ValueBet
                    ValuePrize: ['ValuePrize', 'sum'], // Sum ValuePrize
                },
            });
        });

        var grid2 = $$('datatable'); // Reference to the data table
        grid2.hide(); // Initially hide the data table
        $$('toolbar2').hide(); // Initially hide the second toolbar

        // Event listener for filtering data
        this.on(this.app, 'premiosPendientesPagar:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            var providergroup = 0; // Initialize provider group

            // Iterate through filter data entries
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                        providergroup = 0; // Set provider group to 0
                    } else {
                        providergroup = 1; // Set provider group to 1
                    }
                }
                if (object[i][0] == 'Date') {
                    // Check for Date filter
                    var date = object[i][1].replace(' 00:00:00', ''); // Format date
                    string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query string
                    string1 = string1 + '&dateTo=' + date; // Add dateTo to query string
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Check for Datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (providergroup == 0) {
                // Check provider group
                grid2.show(); // Show data table
                grid.hide(); // Hide tree table
                grid2.clearAll(); // Clear data table
                grid2.load(
                    url + '?start=0&count=' + grid2.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar2').show(); // Show second toolbar
                $$('toolbar').hide(); // Hide first toolbar
            } else {
                grid.show(); // Show tree table
                grid2.hide(); // Hide data table
                grid.clearAll(); // Clear tree table
                grid.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar').show(); // Show first toolbar
                $$('toolbar2').hide(); // Hide second toolbar
            }
            filter = string1; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
